<template>
   <div>
        <section class="contact-section">
    	<div class="auto-container">
        	<div class="row clearfix">
            	
                <!--Form Column-->
                <div class="form-column col-md-7 col-sm-12 col-xs-12">
                	<div class="column-inner">
                        <div class="sec-title">
                            <div class="title">Get In Touch With Us</div>
                            <h2>Send Message</h2>
                        </div>
                    
                    	<!-- Contact Form -->
                        <div class="contact-form ">
                            <!--Comment Form-->
                            <form id="contact-form">
                                <div class="row clearfix">
                                    <div class="col-md-6 col-sm-6 col-xs-12 form-group">
                                        <label>Your Name</label>
                                        <input type="text" name="username" placeholder="Please enter your name" required v-model="contactDetails.name">
                                    </div>
    
                                    <div class="col-md-6 col-sm-6 col-xs-12 form-group">
                                        <label>Email Address</label>
                                        <input type="email" placeholder="Enter valid email Id" required v-model="contactDetails.emailId" name="emailId">
                                        <span class="text-danger" v-show="errors.has('emailId')"><small>{{errors.first('emailId')}}</small></span>
                                    </div>
                                    
                                    <div class="col-md-6 col-sm-6 col-xs-12 form-group">
                                        <label>Phone</label>
                                        <input type="text" name="phone" placeholder="Enter phone number" v-validate="'digits:10'" v-model="contactDetails.phone">
                                        <span class="text-danger" v-show="errors.has('phone')"><small>{{errors.first('phone')}}</small></span>
                                    </div>
                                    
                                    <div class="col-md-6 col-sm-6 col-xs-12 form-group">
                                        <label>Subject</label>
                                        <input type="text" v-model="contactDetails.subject" required>
                                    </div>
    
                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-group">
                                        <label>Message Details</label>
                                        <textarea name="message" placeholder="" v-model="contactDetails.messege"></textarea>
                                    </div>
                                    <div class="form-group" v-show="isSuccess">
                                        <span class="text-danger"> Details saved successfully for further assistance...</span>
                                    </div>
                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-group">
                                        <button class="theme-btn btn-style-two" name="submit-form" @click.prevent="SendRequest">send now</button>
                                    </div>
    
                                </div>
                            </form>
    
                        </div>
                    	<!--End Comment Form -->
                    </div>
                </div>
                
                <!--Info Column-->
                <div class="info-column col-md-5 col-sm-12 col-xs-12">
                	<h2>Address Information</h2>
                    <div class="text">NIRMAN Executive Team is dedicated to coordinate the NIRMAN activities and to help you. You can write to our office to resolve your queries.</div>
                    <ul class="list-style-one">
                    	<li>
                        	<span class="icon flaticon-pin"></span>
                            <h3>Address</h3>
                            <div class="text-info">c/o Mr. Amrut Bang, NIRMAN, SEARCH, Gadchiroli – 442605</div>
                        </li>
                        <li>
                        	<span class="icon flaticon-e-mail-envelope"></span>
                            <h3>Email</h3>
                            <div class="text-info">contact.nirman@gmail.com</div>
                        </li>
                        <li>
                        	<span class="icon flaticon-technology-1"></span>
                            <h3>Phone</h3>
                            <div class="text-info">+(91) 9421 067699</div>
                        </li>
                        <li>
                        	<span class="icon flaticon-earth-grid-symbol"></span>
                            <h3>Website</h3>
                            <div class="text-info">www.nirman.mkcl.org</div>
                        </li>
                    </ul>
                    <!--Social Icon Three-->
                    <ul class="social-icon-three">
                        <li><a href="https://www.facebook.com/nirmanforyouth/" target="_blank"><span class="fa fa-facebook"></span></a></li>
                        <li><a href="https://www.youtube.com/user/Nirmaanites" target="_blank"><span class="fa fa-youtube"></span></a></li>
                        <li><a href="http://simollanghan.blogspot.com/" target="_blank"><span class="fa fa-rss"></span></a></li>
                        <li><a href="http://nirman.mkcl.org/people/net" target="_blank"><span class="fa fa-envelope"></span></a></li>
                        <li><a href="https://www.instagram.com/nirmanforyouth/" target="_blank"><span class="fa fa-instagram"></span></a></li>
                        <li><a href="http://nirman.mkcl.org/people/how-can-you-contribute" data-toggle="tooltip" title="Contribute" target="_blank"><span><img src="static/assets/images/contribute-icon.png" alt="" class="img-responsive icon-header-top"></span></a></li>
                    </ul>
                </div>
                
            </div>
        </div>
    </section>
      <div>
      </div>
   </div>
</template>

<script>
import axios from 'axios'
export default {
name:'contactUs',
  components: {
  },
  data() {
    return {
      contactDetails: {
        name: '',
        phone: '',
        emailId: '',
        subject: '',
        messege: ''
      },
      isSuccess: false
    }
  },
  methods: {
    SendRequest () {
      this.$validator.validateAll()
      if (!this.errors.any()) {
        return new Promise((resolve, reject) => {
          axios.post('/o/mail/sendmail', this.contactDetails).then(response => {
            if (response.status === 200) {
              this.isSuccess = true
              this.contactDetails.name = '',
              this.contactDetails.phone = '',
              this.contactDetails.emailId = '',
              this.contactDetails.subject = '',
              this.contactDetails.messege = ''
              this.$toasted.success('Request sent to our team...', {
                'duration': 3000
              })
              resolve()
            }
          }).catch(err => {
            console.log(err)
            this.$toasted.error('Error occured while registering details...')
            reject(err)
          })
        })
      } else {
        this.$toasted.error('Please provide valid details...')
        return
      }
    }
  },
   created: function () {
  },
   mounted: function () {
  }
}
</script>

<style>

/* img {
  width: 30%;
  margin: auto;
  display: block;
  margin-bottom: 10px;
}
.main-div {
  margin-left: 515px;
  margin-top: 15px;
} */
</style>



// WEBPACK FOOTER //
// contactUs.vue?8c7b1f64